// ─────────────────────────────────────────────────────────────
// Tag
// Extracted from App.js.
// ─────────────────────────────────────────────────────────────

export function Tag({ label, color, bg }) {
  return <span style={{ background: bg || color + "18", border: `1px solid ${color}30`, color, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600 }}>{label}</span>;
}

